import React from 'react'
import SvgIcon, { SvgIconProps } from 'components/Luxkit/SvgIcon'

function LineQuestionCircleIcon(props: SvgIconProps) {
  return <SvgIcon {...props} fill="none" viewBox="0 0 24 24">
    <path fill="currentColor" d="M11.29 15.29a1.5735 1.5735 0 0 0-.12.15.7618.7618 0 0 0-.09.18.6434.6434 0 0 0-.06.18 1.3624 1.3624 0 0 0 0 .2.8395.8395 0 0 0 .08.38.8999.8999 0 0 0 .54.54.94.94 0 0 0 .76 0 .8999.8999 0 0 0 .54-.54A.9997.9997 0 0 0 13 16a1.0003 1.0003 0 0 0-.6154-.9289.9997.9997 0 0 0-1.0946.2189ZM12 2a10 10 0 1 0 0 20.0001A10 10 0 0 0 12 2Zm0 18a8.0005 8.0005 0 0 1-7.391-4.9385A8 8 0 1 1 12 20Zm0-13a3 3 0 0 0-2.6 1.5 1 1 0 1 0 1.73 1A.9999.9999 0 0 1 12 9a1 1 0 1 1 0 2 1.0001 1.0001 0 0 0-1 1v1a1.0001 1.0001 0 0 0 2 0v-.18a3.0002 3.0002 0 0 0 1.9334-3.3281A2.9999 2.9999 0 0 0 12 7Z"/>
  </SvgIcon>
}

export default LineQuestionCircleIcon
